import useSWR, { mutate } from "swr";
import fetcher from "@adora/shared/utils/fetch";
import post from "@adora/shared/utils/post";
import { RelativeUrl } from "@adora/shared/utils/environment";

export interface ExperimentProduct {
  id: number;
  brand_id: number;
  name: string;
  image_path?: string;
}

interface CreateExperimentProductRequest {
  brand_id: number;
  name: string;
}

function getExperimentProductsUrl(brandId: string | number | undefined) {
  const baseUrl = `${RelativeUrl}/experiment_products`;
  return brandId ? `${baseUrl}?brand_id=${encodeURIComponent(String(brandId))}` : null;
}

export default function useExperimentProducts(brandId: string | number | undefined) {
  const { data, error, isLoading } = useSWR(
    getExperimentProductsUrl(brandId),
    (url) => fetcher<ExperimentProduct[]>(url),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true
    }
  );

  const createProduct = async (request: CreateExperimentProductRequest): Promise<ExperimentProduct | null> => {
    if (!brandId) return null;

    const result = await post<ExperimentProduct>(
      `${RelativeUrl}/experiment_products`,
      {},
      { brand_id: request.brand_id, name: request.name }
    );

    return result.match(
      (error) => {
        console.error("Failed to create product:", error);
        return null;
      },
      (product) => {
        // Refresh the products list after successful creation
        mutate(getExperimentProductsUrl(brandId));
        return product;
      }
    );
  };

  return {
    products: data || [],
    isLoading,
    error,
    createProduct
  };
}
